module.exports = __webpack_public_path__ + "firasans-light-webfont.4331a663354b8ef82945.woff2";


//////////////////
// WEBPACK FOOTER
// C:/Users/sherr/Desktop/bsf-website/src/assets/fonts/firasans-light-webfont.woff2
// module id = ../../../../../src/assets/fonts/firasans-light-webfont.woff2
// module chunks = 1